export default __webpack_public_path__ + "static/care-do-bg-5fc832a8366997c26592c5961dcdc94a.jpg";